import { observable, runInAction } from "mobx";
import { ColLineModel, IChartServices, NowPreviousModel, TotalCustomerModel, ValueCustomerModel } from "services/Main/chart_services";
import { DataResponse } from "services/response";

export type ChartStore = {
    // Lấy data tỉ lệ khách hàng theo loại ValueCustomerModel
    listCustomerTypeResponse: DataResponse<Array<ValueCustomerModel>>;
    // Lấy data tỉ lệ khách hàng theo nhóm
    listPercentCustomerGroupResponse: DataResponse<Array<ValueCustomerModel>>;
    // Lấy data tỉ lệ khách hàng theo khu vực
    listPercentCustomerSaleOfficeResponse: DataResponse<Array<ValueCustomerModel>>;
    // Lấy data số lượng nhóm khách hàng theo nhóm
    listNumberCustomerGroupResponse: DataResponse<Array<TotalCustomerModel>>;
    // Lấy data số lượng khách hàng theo khu vực
    listNumberCustomerSaleOfficeResponse: DataResponse<Array<TotalCustomerModel>>;
    // Lấy data top 10 tỉnh thành có số lượng khách hàng cao nhất
    listTop10CustomerProvinceResponse: DataResponse<Array<TotalCustomerModel>>;
    // Lấy data số lượng khách hàng thăm npp/srnq tháng này và tháng trước
    listCustomerVisitingDistributersResponse: DataResponse<Array<NowPreviousModel>>;
    // Lấy data số lượng khách hàng thăm showroom tháng này và tháng trước
    listCustomerVisitingShowroomResponse: DataResponse<Array<NowPreviousModel>>;
    // Lấy data tổng hợp điểm trưng bày
    listShowroomResponse: DataResponse<Array<ColLineModel>>;
    // Lấy data tổng hợp xử lý khiếu nại theo nhóm hàng
    listProductIssueGroupResponse: DataResponse<Array<ColLineModel>>;
    // Lấy data tổng hợp xử lý khiếu nại lỗi thường gặp
    listProductIssueErrorResponse: DataResponse<Array<ColLineModel>>;
    // Lấy data tổng hợp xuất nhập tồn catalog
    listCatalogResponse: DataResponse<Array<TotalCustomerModel>>;
    // Lấy data thị hiếu khách hàng đến showroom
    listCustomerTastesResponse: DataResponse<Array<TotalCustomerModel>>;
    // Lấy data tổng hợp thị hiếu sản phẩm
    listStatisticLikeViewResponse: DataResponse<Array<TotalCustomerModel>>;
}

export interface IChartPresenter {
    createStore(): ChartStore;
    // Lấy data tỉ lệ khách hàng theo loại 
    getListCustomerType(store: ChartStore, companyCode: string): Promise<void>;
    // Lấy data tỉ lệ khách hàng theo nhóm
    getlListPercentCustomerGroup(store: ChartStore, companyCode: string): Promise<void>;
    // Lấy data số lượng nhóm khách hàng theo nhóm
    getListNumberCustomerGroup(store: ChartStore, companyCode: string): Promise<void>;
    // Lấy data tỉ lệ khách hàng theo khu vực
    getListPercentCustomerSaleOffice(store: ChartStore, companyCode: string): Promise<void>;
    // Lấy data số lượng khách hàng theo khu vực
    getListNumberCustomerSaleOffice(store: ChartStore, companyCode: string): Promise<void>;
    // Lấy data top 10 tỉnh thành có số lượng khách hàng cao nhất
    getListTop10CustomerProvince(store: ChartStore, companyCode: string): Promise<void>;
    // Lấy data số lượng khách hàng  thăm npp/srnq tháng này và tháng trước
    getListCustomerVisitingDistributers(store: ChartStore, companyCode: string): Promise<void>;
    //Lấy data số lượng khách hàng thăm showroom tháng này và tháng trước
    getListCustomerVisitingShowroom(store: ChartStore, companyCode: string): Promise<void>;
    // Lấy data tổng hợp điểm trưng bày
    getListShowroom(store: ChartStore, companyCode: string): Promise<void>;
    // Lấy data tổng hợp xử lý khiếu nại theo nhóm hàng
    getListProductIssueGroup(store: ChartStore, companyCode: string): Promise<void>;
    // Lấy data tổng hợp xử lý khiếu nại lỗi thường gặp
    getListProductIssueError(store: ChartStore, companyCode: string): Promise<void>;
    // Lấy data tổng hợp xuất nhập tồn catalog
    getListCatalog(store: ChartStore, companyCode: string): Promise<void>;
    // Lấy data thị hiếu khách hàng đến showroom
    getListCustomerTastes(store: ChartStore, companyCode: string): Promise<void>;
    // Lấy data tổng hợp thị hiếu sản phẩm
    getListStatisticLikeView(store: ChartStore, companyCode: string): Promise<void>;
}

export function createChartPresenter({ chartServices }: { chartServices: IChartServices }): IChartPresenter {
    return {
        createStore: (): ChartStore =>
            observable({
                // Lấy data tỉ lệ khách hàng theo loại 
                listCustomerTypeResponse: {
                    data: [],
                    message: '',
                    isSuccess: false,
                },
                // Lấy data tỉ lệ khách hàng theo nhóm
                listPercentCustomerGroupResponse: {
                    data: [],
                    message: '',
                    isSuccess: false,
                },
                // Lấy data số lượng nhóm khách hàng theo nhóm
                listNumberCustomerGroupResponse: {
                    data: [],
                    message: '',
                    isSuccess: false,
                },
                // Lấy data tỉ lệ khách hàng theo khu vực
                listPercentCustomerSaleOfficeResponse: {
                    data: [],
                    message: '',
                    isSuccess: false,
                },
                // Lấy data số lượng khách hàng theo khu vực
                listNumberCustomerSaleOfficeResponse: {
                    data: [],
                    message: '',
                    isSuccess: false,
                },
                // Lấy data top 10 tỉnh thành có số lượng khách hàng cao nhất
                listTop10CustomerProvinceResponse: {
                    data: [],
                    message: '',
                    isSuccess: false,
                },
                // Lấy data số lượng khách hàng thăm npp/srnq tháng này và tháng trước
                listCustomerVisitingDistributersResponse: {
                    data: [],
                    message: '',
                    isSuccess: false,
                },
                // Lấy data số lượng khách hàng thăm showroom tháng này và tháng trước
                listCustomerVisitingShowroomResponse: {
                    data: [],
                    message: '',
                    isSuccess: false,
                },
                // Lấy data tổng hợp điểm trưng bày
                listShowroomResponse: {
                    data: [],
                    message: '',
                    isSuccess: false,
                },
                // Lấy data tổng hợp xử lý khiếu nại theo nhóm hàng
                listProductIssueGroupResponse: {
                    data: [],
                    message: '',
                    isSuccess: false,
                },
                // Lấy data tổng hợp xử lý khiếu nại lỗi thường gặp
                listProductIssueErrorResponse: {
                    data: [],
                    message: '',
                    isSuccess: false,
                },
                // Lấy data tổng hợp xuất nhập tồn catalog
                listCatalogResponse: {
                    data: [],
                    message: '',
                    isSuccess: false,
                },
                // Lấy data thị hiếu khách hàng đến showroom
                listCustomerTastesResponse: {
                    data: [],
                    message: '',
                    isSuccess: false,
                },
                // Lấy data tổng hợp thị hiếu sản phẩm
                listStatisticLikeViewResponse: {
                    data: [],
                    message: '',
                    isSuccess: false,
                },
            }),

        // Lấy data tỉ lệ khách hàng theo loại 
        getListCustomerType: async (store, companyCode) => {
            try {
                const result = await chartServices.getListCustomerType(companyCode);
                runInAction(() => {
                    store.listCustomerTypeResponse.data = result.data;
                    store.listCustomerTypeResponse.message = result.message;
                    store.listCustomerTypeResponse.isSuccess = result.isSuccess;
                });
            } catch (error) {
                console.log(error);
            }
        },
        // Lấy data tỉ lệ khách hàng theo nhóm
        getlListPercentCustomerGroup: async (store, companyCode) => {
            try {
                const result = await chartServices.getlListPercentCustomerGroup(companyCode);
                runInAction(() => {
                    store.listPercentCustomerGroupResponse.data = result.data;
                    store.listPercentCustomerGroupResponse.message = result.message;
                    store.listPercentCustomerGroupResponse.isSuccess = result.isSuccess;
                });
            } catch (error) {
                console.log(error);
            }
        },
        // Lấy data số lượng nhóm khách hàng theo nhóm
        getListNumberCustomerGroup: async (store, companyCode) => {
            try {
                const result = await chartServices.getListNumberCustomerGroup(companyCode);
                runInAction(() => {
                    store.listNumberCustomerGroupResponse.data = result.data;
                    store.listNumberCustomerGroupResponse.message = result.message;
                    store.listNumberCustomerGroupResponse.isSuccess = result.isSuccess;
                });
            } catch (error) {
                console.log(error);
            }
        },
        // Lấy data tỉ lệ khách hàng theo khu vực
        getListPercentCustomerSaleOffice: async (store, companyCode) => {
            try {
                const result = await chartServices.getListPercentCustomerSaleOffice(companyCode);
                runInAction(() => {
                    store.listPercentCustomerSaleOfficeResponse.data = result.data;
                    store.listPercentCustomerSaleOfficeResponse.message = result.message;
                    store.listPercentCustomerSaleOfficeResponse.isSuccess = result.isSuccess;
                });
            } catch (error) {
                console.log(error);
            }
        },
        // Lấy data số lượng khách hàng theo khu vực
        getListNumberCustomerSaleOffice: async (store, companyCode) => {
            try {
                const result = await chartServices.getListNumberCustomerSaleOffice(companyCode);
                runInAction(() => {
                    store.listNumberCustomerSaleOfficeResponse.data = result.data;
                    store.listNumberCustomerSaleOfficeResponse.message = result.message;
                    store.listNumberCustomerSaleOfficeResponse.isSuccess = result.isSuccess;
                });
            } catch (error) {
                console.log(error);
            }
        },
        // Lấy data top 10 tỉnh thành có số lượng khách hàng cao nhất
        getListTop10CustomerProvince: async (store, companyCode) => {
            try {
                const result = await chartServices.getListTop10CustomerProvince(companyCode);
                runInAction(() => {
                    store.listTop10CustomerProvinceResponse.data = result.data;
                    store.listTop10CustomerProvinceResponse.message = result.message;
                    store.listTop10CustomerProvinceResponse.isSuccess = result.isSuccess;
                })
            } catch (error) {
                console.log(error);
            }
        },
        // Lấy data số lượng khách hàng thăm npp/srnq tháng này và tháng trước
        getListCustomerVisitingDistributers: async (store, companyCode) => {
            try {
                const result = await chartServices.getListCustomerVisitingDistributers(companyCode);
                runInAction(() => {
                    store.listCustomerVisitingDistributersResponse.data = result.data;
                    store.listCustomerVisitingDistributersResponse.message = result.message;
                    store.listCustomerVisitingDistributersResponse.isSuccess = result.isSuccess;
                })
            } catch (error) {
                console.log(error);
            }
        },
        // Lấy data số lượng khách hàng thăm showroom tháng này và tháng trước
        getListCustomerVisitingShowroom: async (store, companyCode) => {
            try {
                const result = await chartServices.getListCustomerVisitingShowroom(companyCode);
                runInAction(() => {
                    store.listCustomerVisitingShowroomResponse.data = result.data;
                    store.listCustomerVisitingShowroomResponse.message = result.message;
                    store.listCustomerVisitingShowroomResponse.isSuccess = result.isSuccess;
                })
            } catch (error) {
                console.log(error);
            }
        },
        // Lấy data tổng hợp điểm trưng bày
        getListShowroom: async (store, companyCode) => {
            try {
                const result = await chartServices.getListShowroom(companyCode);
                runInAction(() => {
                    store.listShowroomResponse.data = result.data;
                    store.listShowroomResponse.message = result.message;
                    store.listShowroomResponse.isSuccess = result.isSuccess;
                })
            } catch (error) {
                console.log(error);

            }
        },
        // Lấy data tổng hợp xử lý khiếu nại theo nhóm hàng
        getListProductIssueGroup: async (store, companyCode) => {
            try {
                const result = await chartServices.getListProductIssueGroup(companyCode)
                runInAction(() => {
                    store.listProductIssueGroupResponse.data = result.data;
                    store.listProductIssueGroupResponse.message = result.message;
                    store.listProductIssueGroupResponse.isSuccess = result.isSuccess;
                })
            } catch (error) {
                console.log(error);

            }
        },
        // Lấy data tổng hợp xử lý khiếu nại lỗi thường gặp
        getListProductIssueError: async (store, companyCode) => {
            try {
                const result = await chartServices.getListProductIssueError(companyCode)
                runInAction(() => {
                    store.listProductIssueErrorResponse.data = result.data;
                    store.listProductIssueErrorResponse.message = result.message;
                    store.listProductIssueErrorResponse.isSuccess = result.isSuccess;
                })
            } catch (error) {
                console.log(error);

            }
        },
        // Lấy data tổng hợp xuất nhập tồn catalog
        getListCatalog: async (store, companyCode) => {
            try {
                const result = await chartServices.getListCatalog(companyCode)
                runInAction(() => {
                    store.listCatalogResponse.data = result.data;
                    store.listCatalogResponse.message = result.message;
                    store.listCatalogResponse.isSuccess = result.isSuccess;
                })
            } catch (error) {
                console.log(error);

            }
        },
        // Lấy data thị hiếu khách hàng đến showroom
        getListCustomerTastes: async (store, companyCode) => {
            try {
                const result = await chartServices.getListCustomerTastes(companyCode)
                runInAction(() => {
                    store.listCustomerTastesResponse.data = result.data;
                    store.listCustomerTastesResponse.message = result.message;
                    store.listCustomerTastesResponse.isSuccess = result.isSuccess;
                })
            } catch (error) {
                console.log(error);
            }
        },
        // Lấy data tổng hợp thị hiếu sản phẩm
        getListStatisticLikeView: async (store, companyCode) => {
            try {
                const result = await chartServices.getListStatisticLikeView(companyCode)
                runInAction(() => {
                    store.listStatisticLikeViewResponse.data = result.data;
                    store.listStatisticLikeViewResponse.message = result.message;
                    store.listStatisticLikeViewResponse.isSuccess = result.isSuccess;
                })
            } catch (error) {
                console.log(error);
            }
        },
    }
}